import { glyph } from '../../../theme/glyph';

export const tokenTypes = {
  string: 'string',
  number: 'number',
  boolean: 'boolean',
  image: 'image',
  error: 'error',
  unavailable: 'unavailable',
};

export const iconMap = {
  [tokenTypes.string]: glyph.logic.string,
  [tokenTypes.number]: glyph.logic.number,
  [tokenTypes.boolean]: glyph.logic.boolean,
  [tokenTypes.image]: glyph.logic.image,
  [tokenTypes.error]: glyph.core.exclamationmarkTriangleFill,
  [tokenTypes.unavailable]: glyph.core.questionmarkSmall,
};
